import { Pipe, PipeTransform } from '@angular/core';
import { ReservationTag } from '@model/reservation-tag';

@Pipe({
  name: 'tagsWrap',
})
export class TagsWrapPipe implements PipeTransform {

  transform(tags: ReservationTag[], chunkSize: number = 3, ...args: unknown[]): ReservationTag[][] {
    return Array.from(
      { length: Math.ceil(tags.length / chunkSize) },
      (_, i) => tags.slice(i * chunkSize, i * chunkSize + chunkSize)
    );
  }

}
